export const baseUrls = {
  DEVELOPMENT: {
    ASSESSMENT_SERVICE:
      process.env.REACT_APP_ASSESSMENT_SERVICE_URL ||
      "https://assessment-api-qa.insightfultraits.com/",
  },
  QA: {
    ASSESSMENT_SERVICE: "https://assessment-api-qa.insightfultraits.com/",
  },
  STAGING: {
    ASSESSMENT_SERVICE: "https://assessment-api.insightfultraits.com/",
  },
  PRODUCTION: {
    ASSESSMENT_SERVICE: "https://assessment-api.insightfultraits.com/",
  },
};
// local : "https://localhost:5101/"
// prod  :  "https://assessment-api.insightfultraits.com/"
//staging : "https://assessment-api-staging.insightfultraits.com/"
